import React, { createContext, useContext, ReactNode } from 'react'
import { TabGroups, createTabGroups } from '../components/SideMenu'
import apiService from 'services/api'

interface SideMenuContextType {
  tabGroups: TabGroups
  logoCount: number
  isLoading: boolean
}

const SideMenuContext = createContext<SideMenuContextType | undefined>(
  undefined
)

export function SideMenuProvider({ children }: { children: ReactNode }) {
  const api = apiService()
  const { data: logos, isLoading } = api.useGetCompanyLogos()

  const logoCount = logos?.length || 0
  const tabGroups = createTabGroups(logoCount)

  return (
    <SideMenuContext.Provider
      value={{
        tabGroups,
        logoCount,
        isLoading,
      }}
    >
      {children}
    </SideMenuContext.Provider>
  )
}

export function useSideMenu(): SideMenuContextType {
  const context = useContext(SideMenuContext)
  if (context === undefined) {
    throw new Error('useSideMenu must be used within a SideMenuProvider')
  }
  return context
}
